// extracted by mini-css-extract-plugin
export default {"level-selector":"AddEmployeeModal_level-selector__E2d5v"};